<!-- 账户查询 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container account-inquire">
      <p v-loading="pLoading">
        <span class="span-green">{{ $t('fi.type.ac.e') }}:</span> <span class="span-red">{{ sumObj.canUseFd }}</span>
        <span class="span-green" v-if="sumObj.canUseNv">{{ $t('fi.type.ac.consume') }}:</span> <span class="span-red">{{ sumObj.canUseNv }}</span>
        <span class="span-green" v-if="sumObj.canUseH0"> {{ $t('fi.type.ac.point') }}:</span> <span class="span-red">{{ sumObj.canUseH0 }}</span>
      </p>
      <el-form size="small" :inline="true" :model="listQuery" label-position="right">
        <!-- 创建时间 -->
        <el-form-item :label="$t('Common.createTime') + ':'" >
          <el-date-picker
              v-model="listQuery.startCreateDate"
              type="date"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
              placeholder=""
          />&nbsp;&nbsp; - &nbsp;&nbsp;
          <el-date-picker
              v-model="listQuery.endCreateDate"
              type="date"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
              placeholder=""
          />
        </el-form-item>
        <!-- 账户类型-->
        <el-form-item :label="$t('fi.lable.account.type') + ':'">
          <el-select v-model="listQuery.acType" placeholder="">
            <el-option value="" />
            <el-option v-for="i in actypeList" :key="i.code" :label="$lt(initDict.actype, i.code)" :value="i.code" />
          </el-select>
        </el-form-item>
        <el-button :loading="btnLoading" type="primary" icon="el-icon-search" size="small" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
      </el-form>
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="50" align="center">
          <template v-slot="{row}">
            <el-button circle size="mini" icon="el-icon-search" :title="$t('button.view')" @click="viewTableBtn(row)" />
          </template>
        </el-table-column>
        <!-- 账户类型 -->
        <el-table-column :label="$t('fi.lable.account.type')" align="center">
          <template v-slot="{row}">
            {{ $lt(initDict.acType, $lt(initDict.actype, row.acType)) }}
          </template>
        </el-table-column>
        <!-- 交易类型 -->
        <el-table-column :label="$t('fiBankbookJournal.dealType')" align="center">
          <template v-slot="{row}">
            <span v-if="row.orderType === 'A01'">{{ $t('efubo.card.record.type2') }}</span>
            <span v-else-if="row.orderType === 'A02'">{{ $t('member.tx') }}</span>
            <span v-else-if="row.orderType === 'A05'">{{ $t('menu.purgoods') }}</span>
            <span v-else>{{ $lt(initDict.orderType, row.orderType) }}</span>
          </template>
        </el-table-column>
        <!-- 存入 -->
        <el-table-column :label="$t('fibankbooktemp.dealtype.A')" align="center">
          <template v-slot="{ row }">
            <span v-if="row.validMoney > 0">{{ row.validMoney }}</span>
            <span v-if="row.validMoney <= 0"></span>
          </template>
        </el-table-column>
        <!-- 取出 -->
        <el-table-column :label="$t('fibankbooktemp.dealtype.D')" align="center">
          <template v-slot="{ row }">
            <span v-if="row.validMoney < 0">{{ row.validMoney }}</span>
            <span v-else-if="row.validMoney >= 0"></span>
          </template>
        </el-table-column>
        <!-- 可用余额 -->
        <el-table-column :label="$t('busi.fi.valid.balance')" prop="validBalance" align="center" />
        <!-- 订单编号 -->
        <el-table-column :label="$t('poOrder.orderNo')" prop="orderNo" align="center" />
        <!-- 创建时间 -->
        <el-table-column :label="$t('Common.createTime')" prop="createTime" align="center" />
        <!-- 摘要 -->
        <el-table-column v-if="this.language === 'zh_CN'" :label="$t('sys.notes')" prop="remark" align="center" />
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import Pagination from "@/components/Pagination"
import {balance} from "@/api/ay-account-manager"
import {balanceSum} from "@/api/member"

export default {
  name: 'AccountInquire',
  components: { Pagination },
  data() {
    return {
      pLoading: false,
      sumObj: {
        canUseFd: '',
        canUseNv: '',
        canUseH0: ''
      },
      btnLoading: false,
      tableLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        startCreateDate:'',
        endCreateDate: '',
        acType: '',
        pageType: '1'
      },
      initDict: {
        actype: 'fiacinput.actype.cn',
        orderType: 'ac_change_order_type'
      }
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'companyCode',
    ]),
    actypeList() {
      if(this.companyCode ==='BD'){
        return this.$ll(this.initDict.actype).filter(ele => ele.code === 'F$')
      }else{
        return this.$ll(this.initDict.actype).filter(ele => ele.code === 'F$' || ele.code === 'H0')
      }
    }
  },
  created() {
    this.getSum()
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      balance({ ...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.tableLoading = false
        this.btnLoading = false
      }).catch(err => {
        console.warn(err)
        this.tableLoading = false
        this.btnLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    viewTableBtn(row) {
      this.$router.push({name: 'ViewAccount', params:{ id: row.id } })
    },
    getSum() {
      this.pLoading = true
      balanceSum().then(res => {
        this.sumObj = res.data
        this.pLoading = false
      }).catch(err => {
        console.error(err)
        this.pLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.account-inquire {
  .span-green {
    color: #55a532;
    font-weight: 700;
  }
  .span-red {
    color: #ff0000;
    margin-right: 10px;
    font-weight: 600;
  }
}

</style>
